import { Link, createFileRoute } from '@tanstack/react-router';
import { Card } from '@/components/ui/card';
import { WikiAnchorSection } from '@/components/wiki/WikiAnchorSection';
import { WikiToc } from '@/components/wiki/WikiToc';
import { GuideActionIcon } from '@/components/icons/GuideActionIcon';

export const Route = createFileRoute('/wiki/politics')({
  component: PoliticsHubPage,
});

function PoliticsHubPage() {
  const toc = [
    { id: 'overview', label: 'Overview' },
    { id: 'kingdom-pages', label: 'Kingdom Pages' },
    { id: 'politics-actions', label: 'Politics Actions' },
  ];

  return (
    <div className="space-y-5">
      <WikiToc items={toc} />

      <WikiAnchorSection id="overview" title="Politics & Coordination Hub">
        <div className="grid gap-4 sm:grid-cols-[120px_1fr]">
          <img
            src="/images/nav/politics@3x.png"
            alt="Politics"
            className="w-full max-w-[120px] rounded-xl border border-[#d4af37]/25"
          />
          <p>
            Kingdom politics is mostly execution discipline: relation control, synchronized calls, and role clarity.
            This section connects leadership tools and diplomatic systems with practical action planning.
          </p>
        </div>
      </WikiAnchorSection>

      <WikiAnchorSection id="kingdom-pages" title="Kingdom Pages">
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {[
            { to: '/kingdom-relations', label: 'Kingdom Relations' },
            { to: '/jubilant', label: 'Jubilant Recovery' },
            { to: '/kingdom-intelligence', label: 'Kingdom Intelligence' },
            { to: '/monarchy', label: 'Monarchy' },
            { to: '/communication', label: 'Communication' },
            { to: '/trade', label: 'Trade & Aid' },
            { to: '/combat', label: 'Combat' },
          ].map(item => (
            <Link key={item.to} to={item.to}>
              <Card className="p-4 transition-colors hover:border-[#d4af37]/40">
                <h3 className="font-cinzel text-lg text-[#f0f0f0]">{item.label}</h3>
              </Card>
            </Link>
          ))}
        </div>
      </WikiAnchorSection>

      <WikiAnchorSection id="politics-actions" title="Coordination Actions">
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {['reconnaissance', 'provoke_discord', 'anonymity', 'dragon_charm', 'spy_on_military', 'spy_on_sciences'].map(actionId => (
            <Link key={actionId} to="/actions/$actionId" params={{ actionId }}>
              <Card className="p-3 transition-colors hover:border-[#d4af37]/40">
                <div className="flex items-center gap-3">
                  <GuideActionIcon
                    code={actionId}
                    alt={actionId.replace(/_/g, ' ')}
                    width={48}
                    height={48}
                    className="h-12 w-12 overflow-hidden rounded-lg border border-[#d4af37]/25"
                  />
                  <span className="font-semibold text-[#e6c547]">{actionId.replace(/_/g, ' ')}</span>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </WikiAnchorSection>
    </div>
  );
}
